import ro from "../../util/browser-detector.js";
import { InAppMessage, logInAppMessageHtmlClick } from "../index.js";
import { OperatingSystems as so } from "../../util/device-constants.js";
import { buildHtmlClickHandler as lt } from "./html-message-display-utils.js";
import { attachHtmlToIframeWithNonce as b } from "../../util/html-display-utils.js";
import { buildBrazeBridge as N } from "../../util/html-display-utils.js";
export default function ct(t, e, o, s, n) {
  var i = document.createElement("iframe");
  i.setAttribute("title", "Modal Message"), s && (i.style.zIndex = (s + 1).toString());
  if (b(i, t.message, n), i.onload = function () {
    var s = i.contentWindow;
    s.focus();
    var l = s.document.getElementsByTagName("head")[0];
    if (null != l) {
      if (t.Oe()) {
        var _e = document.createElement("style");
        _e.innerHTML = t.css || "", _e.id = t.Ge() || "", null != n && _e.setAttribute("nonce", n), l.appendChild(_e);
      }
      var _e2 = s.document.createElement("base");
      null != _e2 && (_e2.setAttribute("target", "_parent"), l.appendChild(_e2));
    }
    var a = s.document.getElementsByTagName("title");
    a && a.length > 0 && i.setAttribute("title", a[0].textContent || "");
    var r = Object.assign(Object.assign({}, N(i, function (e, o) {
      return t.ll(e, o);
    })), {
      closeMessage: function closeMessage() {
        t.ll(i);
      },
      logClick: function logClick() {
        logInAppMessageHtmlClick.apply(void 0, [t].concat(Array.prototype.slice.call(arguments)));
      }
    });
    if (s.appboyBridge = r, s.brazeBridge = r, t.He !== InAppMessage.Ke.Je) {
      var _e3 = s.document.getElementsByTagName("a");
      for (var _s = 0; _s < _e3.length; _s++) _e3[_s].onclick = lt(t, i, _e3[_s], o);
      var _n = s.document.getElementsByTagName("button");
      for (var _e4 = 0; _e4 < _n.length; _e4++) _n[_e4].onclick = lt(t, i, _n[_e4], o);
    }
    var c = s.document.body;
    if (null != c) {
      t.Le() && (c.id = t.htmlId || "");
      var _e5 = document.createElement("hidden");
      _e5.onclick = r.closeMessage, _e5.className = "ab-programmatic-close-button", c.appendChild(_e5);
    }
    s.dispatchEvent(new CustomEvent("ab.BridgeReady")), -1 !== i.className.indexOf("ab-start-hidden") && (i.className = i.className.replace("ab-start-hidden", ""), e(i));
  }, i.className = "ab-in-app-message ab-start-hidden ab-html-message ab-modal-interactions", ro.OS === so.co) {
    var _e6 = document.createElement("div");
    return _e6.className = "ab-ios-scroll-wrapper", _e6.appendChild(i), t.Pe = _e6, _e6;
  }
  return t.Pe = i, i;
}